<ng-container *ngIf="data.path.alias != '/homepage'">
  <div class="container" id="main-container">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10">
        <app-breadcrumbs [path]="data?.path?.alias"></app-breadcrumbs>
      </div>
    </div>
  </div>
  <div class="container">
  
    <div class="row justify-content-center row-shadow">
      <div class="col-12 col-lg-10">
        <div class="cmp-hero">
          <section class="it-hero-wrapper bg-white align-items-start">
            <div class="it-hero-text-wrapper pt-0 ps-0 pb-4 pb-lg-60">
              <h1 class="text-black" data-element="page-name">{{data.title}}</h1>
              <div class="hero-text" *ngIf="data.page_body">
                <p [innerHTML]="data?.page_body?.processed"></p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</ng-container>